import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'antd';

const RDAlert = ({
  alertType,
  alertTitle,
  alertContent,
  alertClosable,
  onCloseAlert,
  alertStyle,
  isAlertIcon,
  isBanner,
}) => (
  <Alert
    message={alertTitle}
    description={alertContent}
    type={alertType}
    closable={alertClosable}
    onClose={onCloseAlert}
    style={alertStyle}
    showIcon={isAlertIcon}
    banner={isBanner}
  />
);

RDAlert.defaultProps = {
  alertContent: '',
  alertType: 'success',
  alertStyle: {},
  alertTitle: '',
  onCloseAlert: () => {},
  isAlertIcon: true,
  alertClosable: true,
  isBanner: false,
};

RDAlert.propTypes = {
  /** Description of Alert */
  alertContent: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  /** Type of Alert styles, Can be set to - success | info | warning | error */
  alertType: PropTypes.string,
  /** Messsage of Alert */
  alertTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  /** Inline style to apply to the alert container */
  alertStyle: PropTypes.shape({}),
  /** Callback when Alert is closed */
  onCloseAlert: PropTypes.func,
  /** Whether to show icon */
  isAlertIcon: PropTypes.bool,
  /** Whether Alert can be closed */
  alertClosable: PropTypes.bool,
  /** Display Alert as a banner at top of page */
  isBanner: PropTypes.bool,
};
export default RDAlert;
